import React from 'react';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Typography, Button, Icon } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import LanguageDropDown from './LanguageDropdown';
import Dashboard from '../Dashboard-log/DashboardNav/Dashboard';
import classNames from 'classnames';
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles';


/************************************************************************************/
                    // START Home.js STYLES //
/************************************************************************************/
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },

    companyNameTypo: {
        textTransform: 'capitalize',
        marginRight: '10px',
        color: 'white',
        '&:hover': {
            backgroundColor: 'none',
            color: 'white',
            cursor: 'pointer',
        }
    },
    
    toolBarOptions: {
        justifyContent: 'space-between',
        height: '81px',
        background: '#001524'
    },

    desktopNav: {
        display: "flex",
        justifyContent: "space-between",
        width: '100%'
    },

    desktopButton: {
        textTransform: 'capitalize',
        marginRight: '10px',
        color: 'white',
        '&:hover': {
            backgroundColor: '#15616d',
            color: 'white',
        }
    },

    disabledButton: {
        textTransform: 'capitalize',
        marginRight: '10px',
        color: 'grey',
        '&:hover': {
            cursor: 'default',
        },
        '&:focus':{
            outline: 'none'
        }
    },

    link: {
        color: 'white',
        '&:hover': {
            color: 'white',
            textDecoration: 'none'
        }
    },

    mobileLink: {
        color: 'black',
        '&:hover': {
            textDecoration: 'none'
        }
    }

}))

/************************************************************************************/
                        // END Home.js STYLES //
/************************************************************************************/

const Navbar = () => {
    const classes = useStyles();
    const history = useHistory();

    /************************************************************************************/
                        // Start of Nav toggle-menu media-query STYLES //
    /************************************************************************************/
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    /************************************************************************************/
                        // END of Nav toggle-menu media-query STYLES //
    /************************************************************************************/

    /************************************************************************************/
                        // START of Nav toggle-dropdown STYLES //
    /************************************************************************************/

    

    /************************************************************************************/
                        // END of Nav toggle-dropdown STYLES //
    /************************************************************************************/

    return (
        <>
        <div className={classes.root}>
            <AppBar position="static">
            <Toolbar className={classes.toolBarOptions}>
                <Typography className={classes.companyNameTypo} onClick={() => history.push('/')}>Transporex</Typography>
                <div>{ isMobile ? (
                    <>
                        <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        >
                        <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onClose={handleMenuClose}
                        >
                            {/* <MenuItem onClick={handleMenuClose}>Home</MenuItem> */}
                            <MenuItem onClick={handleMenuClose}><Link to={'/dashboard'} className={classes.mobileLink}>Find Shipment</Link></MenuItem>
                            <MenuItem onClick={handleMenuClose}><Link to={'/shippers'} className={classes.mobileLink}>Find Shippers</Link></MenuItem>
                            <MenuItem onClick={handleMenuClose} className={classes.disabledButton}>For Businesses</MenuItem>
                            <MenuItem onClick={handleMenuClose} className={classes.disabledButton}>Help</MenuItem>
                            <MenuItem onClick={handleMenuClose} className={classes.disabledButton}>en</MenuItem>
                            <MenuItem onClick={handleMenuClose} className={classes.disabledButton}><Link to={'/login'} className={classes.mobileLink}>Log in</Link></MenuItem>
                            <MenuItem onClick={handleMenuClose}><Link to={'/signup'} className={classes.mobileLink}>Register</Link></MenuItem>
                        </Menu>
                    </>
                    ) : ( 
                        <div className={classes.desktopNav}>  
                            {/* <Button className={classes.desktopButton} disableRipple='true'><Link to={'/dashboard'} className={classes.link}>Create Auction</Link></Button> */}
                            <Button className={classes.desktopButton} disableRipple='true'><Link to={'/dashboard'} className={classes.link}>Find Shipment</Link></Button>
                            <Button className={classes.desktopButton} disableRipple='true'><Link to={'/shippers'} className={classes.link}>Find Shippers</Link></Button>
                            <Button className={classes.disabledButton} disableRipple='true'>For Businesses</Button>
                            <Button className={classes.disabledButton} disableRipple='true'>Help</Button>
                            <LanguageDropDown/>
                            <Button className={classes.desktopButton} disableRipple='true'><Link to={'/login'} className={classes.link}>Log in</Link></Button>
                            <Button className={classes.desktopButton} disableRipple='true' variant="outlined" color='secondary'><Link to={'/signup'} className={classes.link}>Register</Link></Button>
                        </div>
                    )}
                    
                </div>
            </Toolbar>
            </AppBar>
        </div>
        </>
    )
}

export default Navbar;